import { signal } from "@preact/signals";
import { useLocation } from "preact-iso";
import { useEffect } from "preact/hooks";
import { isAuthenticated } from "../store/auth.js";
import { buildAuthUrl } from "../auth/workos.js";

const loading = signal(false);

export default function Login() {
  const { route } = useLocation();

  useEffect(() => {
    if (isAuthenticated.value) {
      route("/dashboard", true);
    }
  }, []);

  function handleSignIn() {
    loading.value = true;
    const state = crypto.randomUUID();
    sessionStorage.setItem("oauth_state", state);
    window.location.href = buildAuthUrl(state);
  }

  return (
    <div class="flex h-screen items-center justify-center">
      <div class="text-center max-w-sm">
        <h1 class="text-2xl font-bold mb-2">webhookstorage</h1>
        <p class="text-gray-600 mb-6">Sign in to manage your webhook endpoints.</p>
        <button
          onClick={handleSignIn}
          disabled={loading.value}
          class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading.value ? "Redirecting…" : "Continue"}
        </button>
        <p class="mt-4">
          <a href="/" class="text-sm text-gray-500 hover:text-gray-700">
            ← Back to home
          </a>
        </p>
      </div>
    </div>
  );
}
